'use client';

import { configKeepData5Mins } from '@/config/useQuery';
import { APP_BUSINESS_DICTIONARY_CODES } from '@/constant/dynamic-form-constants';
import { IHrmThongTinGiangVienResponse } from '@/server/api/v1/employee/hrm-giang-vien';
import { api } from '@/trpc/client';

/**
 * Lấy thông tin giảng viên/cán bộ từ HRM (`HRM_GetThongTinGiangVien`) theo
 * mã nhân sự — dùng `StaffInfo.SoHieuCongChuc` (= `identityCode` của role
 * Staff), khớp với cách submit-dossier.tsx gọi cùng executor này.
 *
 * Dùng để lấy `MaPhanLoai` → tra `mapMaPhanLoaiToStaffCategory` ra nhóm cán bộ
 * (VC/NLĐ, quản lý, BGH) phục vụ LỌC ĐỐI TƯỢNG ở nav-bar "Danh sách thủ tục" —
 * vì `SoHieuCongChuc` KHÔNG chứa thông tin phân loại, không regex ra được.
 *
 * `enabled` chỉ nên bật khi thật sự cần (mode personalized + user là cán bộ +
 * cây loại thủ tục có node gate theo phân loại) để không tốn API call thừa.
 *
 * `isReady`: query không cần chạy (disabled) HOẶC đã fetch xong (success/error).
 * Caller dùng cờ này để CHỜ trước khi render cây / auto-redirect p-types.
 */
export const useQueryThongTinGiangVien = (
    maNhanSu: string = '',
    extendedEnabled: boolean = true
) => {
    const enabled = !!maNhanSu && extendedEnabled;

    const { data, isLoading, isFetching, isFetched } =
        api.appBusinessRequirement.Execute.useQuery(
            {
                Value: APP_BUSINESS_DICTIONARY_CODES.hrm_get_thong_tin_giang_vien,
                Params: {
                    MaNhanSu: maNhanSu,
                },
            },
            {
                ...configKeepData5Mins,
                enabled,
            }
        );

    let thongTinGiangVien: IHrmThongTinGiangVienResponse | undefined = undefined;

    if (data?.isSuccessStatus && Array.isArray(data.data)) {
        thongTinGiangVien = data.data[0];
    }

    return {
        data: thongTinGiangVien,
        isLoading,
        isFetching,
        isReady: !enabled || isFetched,
    };
};
